// extracted by mini-css-extract-plugin
export var container = "_4l-0";
export var disabled = "_4l-4";
export var fullWidth = "_4l-3";
export var lined = "_4l-1";
export var selected = "_4l-5";
export var tab = "_4l-2";